"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AttachmentList;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactVirtualized = require("react-virtualized");
require("react-virtualized/styles.css");
var _excluded = ["columnIndex", "rowIndex"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var COLUMN_WIDTH = 282;
var COLUMN_HEIGHT = 282;
var COLUMN_HINT_HEIGHT = 80;
function AttachmentList(_ref) {
  var total = _ref.total,
    loadMore = _ref.loadMore,
    isLoaded = _ref.isLoaded,
    renderItem = _ref.renderItem,
    hints = _ref.hints;
  var hasHints = !!hints;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-col flex h-full bg-app"
  }, /*#__PURE__*/_react["default"].createElement(_reactVirtualized.InfiniteLoader, {
    isRowLoaded: isLoaded,
    loadMoreRows: loadMore,
    rowCount: total
  }, function (_ref2) {
    var onRowsRendered = _ref2.onRowsRendered,
      registerChild = _ref2.registerChild;
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
      className: "!h-full !w-full flex-grow"
    }, function (_ref3) {
      var height = _ref3.height,
        width = _ref3.width;
      var columnCount = Math.floor(width * 0.8 / COLUMN_WIDTH);
      var rowCount = Math.ceil(total / columnCount) + (hasHints ? 1 : 0);
      return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Grid, {
        ref: registerChild,
        cellRenderer: function cellRenderer(_ref4) {
          var columnIndex = _ref4.columnIndex,
            rowIndex = _ref4.rowIndex,
            rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);
          var index = columnIndex + rowIndex * columnCount;
          if (hasHints) {
            if (rowIndex === 0) {
              var style = rest.style;
              return columnIndex === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
                className: "flex items-center p-4",
                style: _objectSpread(_objectSpread({}, style), {}, {
                  width: COLUMN_WIDTH * columnCount
                })
              }, hints) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
            } else {
              index = columnIndex + (rowIndex - 1) * columnCount;
            }
          }
          return renderItem(_objectSpread({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          }, rest), index);
        },
        onSectionRendered: function onSectionRendered(_ref5) {
          var columnStartIndex = _ref5.columnStartIndex,
            columnStopIndex = _ref5.columnStopIndex,
            rowStartIndex = _ref5.rowStartIndex,
            rowStopIndex = _ref5.rowStopIndex;
          var _map = [rowStartIndex, rowStopIndex].map(function (rowIndex) {
              return Math.max(0, hasHints ? rowIndex - 1 : rowIndex);
            }),
            _map2 = (0, _slicedToArray2["default"])(_map, 2),
            _rowStartIndex = _map2[0],
            _rowStopIndex = _map2[1];
          var startIndex = _rowStartIndex * columnCount + columnStartIndex;
          var stopIndex = _rowStopIndex * columnCount + columnStopIndex;
          return onRowsRendered({
            startIndex: startIndex,
            stopIndex: stopIndex
          });
        },
        rowCount: rowCount,
        columnCount: columnCount,
        columnWidth: COLUMN_WIDTH,
        rowHeight: function rowHeight(_ref6) {
          var index = _ref6.index;
          return index === 0 && hasHints ? COLUMN_HINT_HEIGHT : COLUMN_HEIGHT;
        },
        height: height,
        width: width,
        containerStyle: {
          margin: '0 auto'
        },
        tabIndex: null
      });
    });
  }));
}
//# sourceMappingURL=List.js.map